export enum FormLinkedInModeEnum {
    NONE = 'NONE',
    OPTIONAL = 'OPTIONAL',
    MANDATORY = 'MANDATORY'
}
